/**
 * Argument placeholder. Used with partial.
 * @name _
 */
module.exports = Symbol('PLACEHOLDER')
